import gql from 'graphql-tag';

import categoryFragment from '~/shared/graphql-queries/categories/category-fragment';

export default gql`
  mutation updateByIdCategoryMutation(
    $_id: MongoID!
    $record: UpdateByIdCategoryInput!
  ) {
    updateByIdCategoryMutation(_id: $_id, record: $record) {
      recordId
      record {
        ...CategoryFragment
      }
      message
      title
    }
  }
  ${categoryFragment}
`;
